import { Stack, Typography } from '@mui/material';

import SignOutIcon from '../../../assets/icons/SignOutIcon';
import Link from '../../../components/styledComponents/Link';
import colors from '../../../constants/colors';
import useUpdateTitle from '../../../hooks/useUpdateTitle';
import SplitView from '../SplitView';

const Logout = () => {
  useUpdateTitle('Sign Out');
  return (
    <SplitView data-testid="logout-page" Icon={<SignOutIcon />}>
      <Stack
        direction="column"
        sx={{
          justifyContent: { mobile: 'flex-start', desktop: 'center' },
          px: { mobile: 2, tablet: 14, desktop: 11 },
          height: '100%'
        }}>
        <Typography
          variant="h1"
          sx={{
            fontWeight: 700,
            fontSize: { mobile: 33, tablet: 44 },
            lineHeight: { mobile: '48px', desktop: '56px' },
          }}
        >
          You have signed out of MyPolicy.
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 500,
            fontSize: { mobile: 23, tablet: 28 },
            lineHeight: { mobile: '32px', desktop: '40px' },
            mt: { mobile: 1, tablet: 1, desktop: 2 },
            color: colors.csaaDark,
          }}
        >
          If your session timed out,{' '}
          <Link
            to="/login"
            sx={{ fontSize: 'inherit', fontWeight: 'inherit' }}
            replace
          >
            Sign in
          </Link>{' '}
          again.
        </Typography>
      </Stack>
    </SplitView>
  );
};

export default Logout;
